import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LogService } from '@innovation-os-ng/core/logger';

@Injectable({
  providedIn: 'root'
})
export class LoggerErrorHandler implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: Error) {
    const logger = this.injector.get(LogService);
    logger.error(error, { error: error ? error.stack : 'Error Stack is undefined.' });
  }
}
